import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryApplicationsEffects } from './category-applications.effects';
import { categoryApplicationsReducer } from './category-applications.reducer';

export const provideCategoryApplicationsStore = () => [
  provideState('categoryApplications', categoryApplicationsReducer),
  provideEffects([CategoryApplicationsEffects]),
];
